module.exports = __webpack_public_path__ + "img/letterhead.dfbb0470.jpg";